export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/ob-step-9.png?625fa35a159684d9465562ee5f57b77f";